import styled from 'styled-components';

import { Button, TextButton } from '@xing-com/button';
import {
  xdlColorButtonStrong,
  xdlColorButtonStrongHover,
  xdlColorControlFillTertiary,
  xdlColorDisabledSoft,
  xdlColorDisabledStrong,
  xdlColorTextInvert,
  xdlColorTextOnDark,
  xdlPaletteGrayPlain11,
} from '@xing-com/tokens';

const Container = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  height: 80px;
  padding: 0 24px;
  column-gap: 18px;
  align-items: center;
  justify-content: flex-end;
  border-radius: 0 0 3px 3px;
`;

const BlackButton = styled(Button)`
  color: ${xdlColorTextInvert};
  &::after {
    background-color: ${xdlColorButtonStrong};
  }
  &:hover::after {
    background-color: ${xdlColorButtonStrongHover};
    @media (hover: none) {
      background-color: ${xdlColorControlFillTertiary};
    }
  }
  &:active {
    color: ${xdlColorTextOnDark};
    &::after {
      background-color: ${xdlPaletteGrayPlain11};
      transform: scale(0.95);
    }
  }
  &:disabled {
    color: ${xdlColorDisabledStrong};
    &::after {
      background-color: ${xdlColorDisabledSoft};
      transform: none;
      &:hover::after {
        background-color: transparent;
      }
    }
  }
  &[aria-label='loading'] {
    &::after {
      background-color: ${xdlColorControlFillTertiary};
    }
  }
`;

const StyledTextButton = styled(TextButton)`
  padding-right: 20px;
`;

const StyledButton = styled(Button)`
  padding-right: 20px;
`;

export const Styled = {
  Container,
  BlackButton,
  StyledButton,
  StyledTextButton,
};
